
import ArrowRight4 from "../../../assets/duotone/ArrowRight4.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowRight4Icon({ className, dataTestid = "ArrowRight4Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowRight4 data-testid={dataTestid} className={classes} {...rest} />
  );
}
